// extracted by mini-css-extract-plugin
export var inline = "_w0-0";